const ja = {
    'App.Title': 'OKICABusiness',
    'App.Account': 'アカウント',
    'App.AccountClose': '閉じる',

    // 日時の表示フォーマット
    'DateFormat.LongDateTime': 'YYYY/MM/DD HH:mm',
    'DateFormat.ShortDateTime': 'MM/DD HH:mm',
    'DateFormat.Time': 'HH:mm',

    //エラーメッセージ
    'Error.Unauthorized': 'ログインステータスが無効です。もう一度ログインしてください。',
    'Error.Forbidden': 'ユーザーには必要なアクセス許可がありません',
    'Error.InternalServerError': '処理中に問題が発生しました。',
    'Error.BadRequest': 'Invitation_is_already_completed.',
    'Error.Required': '必須項目です。',
    'Error.KatakanaName': '全角カタカナを入力してください。',
    'Error.Number': '数字を入力してください。',
    'Error.HankakuNumber': '半角数字を入力してください。',
    'Error.Hankakueisu': '半角英数字を入力してください。',
    'Error.Email': '不正なメールアドレス形式です。',
    'Error.EnglishName': '英語のアルファベットを入力してください。',
    'Error.Length': '最大長を超えました。',
    'Error.DecimalNumber': '整数部2桁、小数以下1桁。',
    'Error.Range': '番号は0から100の範囲でなければなりません。',

    'Error.FeeMaxLen': '最大6文字で入力してください。',
    'Error.FeeMin': '0.00以上で入力してください。',
    'Error.FeeMax': '100.00以下で入力してください。',
    'Error.FeePattern': '0.00～100.00で入力してください。',

    'Error.PointNameMaxLen': '最大50文字で入力してください。',
    'Error.PointMaxLen': '最大5文字で入力してください。',
    'Error.PointMin': '0.0以上で入力してください。',
    'Error.PointMax': '100.0以下で入力してください。',
    'Error.PointPattern': '整数部2桁、小数部以下1桁の半角数字0.0～100.0で入力してください。',

    'Error.ShopCd1_Pattern': '13桁の半角数値で入力してください。',
    'Error.ShopCd2_Pattern': '4桁の半角数値で入力してください。',
    'Error.ShopCd3_Pattern': '6桁の半角数値で入力してください。',
    'Error.ShopCd4_Pattern': '6桁の半角数値で入力してください。',

    'Error.ShopLonMinPattern': '経度：123.000000以上で入力してください（日本国内の範囲）',
    'Error.ShopLonMaxPattern': '経度：154.000000以下で入力してください（日本国内の範囲）',
    'Error.ShopLatMinPattern': '緯度：20.000000以上で入力してください（日本国内の範囲）.',
    'Error.ShopLatMaxPattern': '緯度：45.000000以下で入力してください（日本国内の範囲）',


    'Error.TerminalInstallIdPattern': '先頭’Ｍ’の半角英数字17桁で入力してください',

    'Error.TerminalMerchantOrgInfoPattern': '最大20文字で入力してください。',

    'Error.ShopName1MaxLenPattern': '最大50文字で入力してください。',
    'Error.ShopName2MaxLenPattern': '最大100文字で入力してください。',
    'Error.ShopPostalMinLenPattern': '7文字で入力してください。',
    'Error.ShopPostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.ShopAdressMaxLenPattern': '最大255文字で入力してください。',
    'Error.ShopLatLonMaxLenPattern': '少数第6桁までで入力してください。',
    'Error.ShopLatLonPattern': '度数表記　世界測地系で入力してください。',
    'Error.ShopTelFaxMinLenPattern': '10文字で入力してください。',
    'Error.ShopTelFaxMaxLenPattern': '最大12文字で入力してください。',
    'Error.ShopDealInfoMaxLenPattern': '最大500文字で入力してください。',

    'Error.AccountEmailPattern': '最大256文字で入力してください。',
    'Error.AccountNamePattern': '最大128文字で入力してください。',
    'Error.AccountPassWordPattern': '8文字以上で、大文字(A〜Z)、小文字(a〜z)、数字(0〜9)、特殊文字(！@＃$％^＆*など)のいずれかを3つ以上を含む必要があります。',
    'Error.AccountPassWordMatchPattern': 'パスワードが一致しません。',

    'Error.AcquirerContactNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.AcquirerContactDepartMaxLenPattern': '最大40文字で入力してください。',
    'Error.AcquirerTelMinLenPattern': '10文字以上で入力してください。',
    'Error.AcquirerTelMaxLenPattern': '最大12文字で入力してください。',
    'Error.AcquirerEmailMaxLenPattern': '最大256文字で入力してください。',
    'Error.AcquirerCorporatNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.AcquirerCorporatNoMinLenPattern': '12文字で入力してください。',
    'Error.AcquirerCorporatNoMaxLenPattern': '最大12文字で入力してください。',
    'Error.AcquirerMerchantNameMaxLenPattern': '最大25文字で入力してください。',
    'Error.AcquirerMerchantEnglishNameMaxLenPattern': '最大100文字で入力してください。',

    'Error.AcquirerMerchantPostalMinLenPattern': '7文字で入力してください。',
    'Error.AcquirerMerchantPostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.AcquirerMerchantAdressMaxLenPattern': '最大100文字で入力してください。',
    'Error.AcquirerMerchantTelFaxMinLenPattern': '10文字以上で入力してください。',
    'Error.AcquirerMerchantTelFaxMaxLenPattern': '最大12文字以上で入力してください。',
    'Error.AcquirerMerchantCapitalMaxLenPattern': '最大9桁で入力してください。',
    'Error.AcquirerMerchantAnnualSaleMaxLenPattern': '最大9桁で入力してください。',
    'Error.AcquirerMerchantEmployeesNumberMaxLenPattern': '最大5桁で入力してください。',
    'Error.AcquirerMerchantTempNumberMaxLenPattern': '最大4桁で入力してください。',
    'Error.AcquirerMerchantBusinessContentMaxLenPattern':'最大500文字で入力してください。',

    'Error.AcquirerDelegateNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.AcquirerDelegatePostalMinLenPattern': '7文字で入力してください。',
    'Error.AcquirerDelegatePostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.AcquirerDelegateAdressMaxLenPattern': '最大100文字で入力してください。',
    'Error.AcquirerDelegateTelMinLenPattern': '10文字以上で入力してください。',
    'Error.AcquirerDelegateTelMaxLenPattern': '最大12文字で入力してください。',

    'Error.AcquirerFinancialNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.AcquirerFinancialCdMinLenPattern': '4文字で入力してください。',
    'Error.AcquirerFinancialCdMaxLenPattern': '最大4文字で入力してください。',
    'Error.AcquirerFinancialBranchNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.AcquirerFinancialBranchNoMinLenPattern': '3文字で入力してください。',
    'Error.AcquirerFinancialBranchNoMaxLenPattern': '最大3文字で入力してください。',
    'Error.AcquirerFinancialAccountNoMinLenPattern': '7文字で入力してください。',
    'Error.AcquirerFinancialAccountNoMaxLenPattern': '最大7文字で入力してください。',
    'Error.AcquirerFinancialAccountHolderMaxLenPattern': '最大50文字で入力してください。',


    'Error.MerchantContactNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.MerchantContactDepartMaxLenPattern': '最大40文字で入力してください。',
    'Error.MerchantTelMinLenPattern': '10文字以上で入力してください。',
    'Error.MerchantTelMaxLenPattern': '最大12文字で入力してください。',
    'Error.MerchantEmailMaxLenPattern': '最大256文字で入力してください。',
    'Error.MerchantCorporatNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.MerchantCorporatNoMinLenPattern': '12文字で入力してください。',
    'Error.MerchantCorporatNoMaxLenPattern': '最大12文字で入力してください。',
    'Error.MerchantPostalMinLenPattern': '7文字で入力してください。',
    'Error.MerchantPostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.MerchantNameMaxLenPattern': '最大25文字で入力してください。',
    'Error.MerchantEnglishNameMaxLenPattern': '最大100文字で入力してください。',

    'Error.MerchantPostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.MerchantAdressMaxLenPattern': '最大100文字で入力してください。',
    'Error.MerchantTelFaxMinLenPattern': '10文字以上で入力してください。',
    'Error.MerchantTelFaxMaxLenPattern': '最大12文字で入力してください。',
    'Error.MerchantCapitalMaxLenPattern': '最大9桁で入力してください。',
    'Error.MerchantAnnualSaleMaxLenPattern': '最大9桁で入力してください。',
    'Error.MerchantEmployeesNumberMaxLenPattern': '最大5桁で入力してください。',
    'Error.MerchantTempNumberMaxLenPattern': '最大4桁で入力してください。',
    'Error.MerchantBusinessContentMaxLenPattern':'最大500文字で入力してください。',
    'Error.MerchantExternalLinkCdMaxLenPattern': '最大6文字で入力してください。',


    'Error.MerchantDelegateNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.MerchantDelegatePostalMinLenPattern': '7文字で入力してください。',
    'Error.MerchantDelegatePostalMaxLenPattern': '最大7文字で入力してください。',
    'Error.MerchantDelegateAdressMaxLenPattern': '最大100文字で入力してください。',
    'Error.MerchantDelegateTelMinLenPattern': '10文字以上で入力してください。',
    'Error.MerchantDelegateTelMaxLenPattern': '最大12文字で入力してください。',

    'Error.MerchantFinancialNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.MerchantFinancialCdMinLenPattern': '4文字で入力してください。',
    'Error.MerchantFinancialCdMaxLenPattern': '最大4文字で入力してください。',
    'Error.MerchantFinancialBranchNameMaxLenPattern': '最大50文字で入力してください。',
    'Error.MerchantFinancialBranchNoMinLenPattern': '3文字で入力してください。',
    'Error.MerchantFinancialBranchNoMaxLenPattern': '最大3文字で入力してください。',
    'Error.MerchantFinancialAccountNoMinLenPattern': '7文字で入力してください。',
    'Error.MerchantFinancialAccountNoMaxLenPattern': '最大7文字で入力してください。',
    'Error.MerchantFinancialAccountHolderMaxLenPattern': '最大50文字で入力してください。',

    // ボタン共通
    'Button.Save': '登録',
    'Button.Back': '戻る',
    'Button.Confirm': '入力内容の確認',
    'Button.Next': '次へ',
    'Button.Application': '申請',
    'Button.AutoInput': '住所自動入力',
    'Button.Delete': '削除',
    'Button.ApplicationOK': '申請OK',
    'Button.Edit': '編集',
    'Button.Update': '入力した内容に変更',
    'Button.Register': '登録',
    'Button.Apply': '申込',
    'Button.ClosePage': 'この ページを閉じる',
    'Button.AddFeeSettings': '設定を追加',
    'Button.DownloadCSV': 'CSVダウンロード',
    'Button.UnprocessedElapse': '未了過去',
    'Button.UnprocessedCarryOver': '未了繰越',
    'Button.Download': 'ダウンロード',
    'Button.Search': '検索',
    'Button.AddSetting': '設定を追加',
    'Button.CancellationApplication': '解約申請',
    'Button.Cancellation': '解約',
    'Button.SkipAccountEntry': 'アカウント入力をスキップ',

    //メニューの説明
    'Menu.Notice': 'お知らせ',
    'Menu.TradeManagement': '取引管理',
    'Menu.Adjustment': '精算',
    'Menu.Profile': 'プロフィール',
    'Menu.Administration': '管理',
    'Menu.Other': 'その他',

    //精算のサブメニューの説明
    'Menu.ListDownload': '精算一覧',
    'Menu.ConfirmPayment': '精算書確認',
    //'Menu.Financial': '金融関連',
    'Menu.BankPayment': '銀行精算',
    'Menu.CreditPayment': 'クレジット精算',
    'Menu.FeeList': '手数料一覧',

    //管理のサブメニューの説明
    'Menu.Acquirer': '代表加盟店',
    'Menu.Merchant': '加盟店',
    'Menu.Shop': '店舗',
    'Menu.Terminal': '端末',
    'Menu.PointManagement': 'ポイント',
    'Menu.PointAggregate': 'ポイント集計',
    'Menu.FeeManagement': '手数料',
    'Menu.Account': 'アカウント',
    'Menu.SalesPromotion': '販促物',

    //その他のサブメニューの説明
    'Menu.TermsOfService': '利用規約',
    'Menu.Logout': 'ログアウト',

    //デフォルトのテーブルの説明
    'Table.SearchPlaceholder': '検索',
    'Table.EmptyDataSourceMessage': '表示するレコードがありません',
    'Table.Action': 'アクション',

    //お知らせ
    'Notice.Title': 'お知らせ',

    //取引管理
    'Trade.Title': '取引管理',
    'Trade.Info': ' カード決済の取引実績は翌日に反映されます',
    'Trade.SubTitle': '取引詳細',
    'Trade.ResultsTitle': '取引一覧',
    'Trade.Search': '検索',
    'Trade.SearchStartDate': '取引日時（開始）',
    'Trade.SearchEndDate': '取引日時（終了）',
    'Trade.SearchStartAmount': '金額（開始）',
    'Trade.SearchEndAmount': '金額（終了）',
    'Trade.SearchMerchantName': '加盟店名',
    'Trade.SearchShopName': '店舗名',
    'Trade.SearchTransactionType': '取引タイプ',
    'Trade.SearchAccountType': '決済種別',
    'Trade.SearchPaymentNo': '決済番号',
    'Trade.SearchTerminalId': '端末機識別番号',
    'Trade.SearchUnfinishType': '未了種別',

    'Trade.ResultsDownload': '結果ダウンロード',
    'Trade.TransactionDt': '取引日時',
    'Trade.FixedDt': '取引完了日時',
    'Trade.MerchantName': '加盟店名',
    'Trade.MerchantType': '加盟店タイプ',
    'Trade.MerchantType.Acquirer': '代表',
    'Trade.MerchantType.General': '一般',
    'Trade.ShopName': '店舗名',
    'Trade.Cancel': '取消',
    'Trade.TransactionType': '取引タイプ',
    'Trade.TransactionType.Fixed': 'QR決済',
    'Trade.TransactionType.Cancel': 'QR決済取消',
    'Trade.TransactionType.Charge': 'QRチャージ',
    'Trade.TransactionType.OkiKoroReserve': 'OKICAカード残額に移動（予約）',
    'Trade.TransactionType.OkiKoro': 'OKICAカード残額に移動',
    'Trade.TransactionType.OkiKoroExpiredRecovery': 'OKICAカード残額に移動（有効期限切れ）',
    'Trade.TransactionType.OkiKoroUnfinishedRecovery': 'OKICAカード残額に移動（処理未了）',
    'Trade.TransactionType.OkiKoroCancelExpired': 'OKICAカード残額への移動取消（有効期限切れ）',
    'Trade.TransactionType.OkiKoroCancel': 'OKICAカード残額への移動取消',
    'Trade.TransactionType.OkiKoroCancelCardExchange': 'OKICAカード残額への移動取消（カード交換/払戻）',
    'Trade.TransactionType.OkiKoroCancelRecovery': 'OKICAカード残額に移動（取消リカバリ）',
    'Trade.TransactionType.SmaKoroReserve': 'SmartOKICA残高に移動（予約）',
    'Trade.TransactionType.SmaKoro': 'SmartOKICA残高に移動',
    'Trade.TransactionType.SmaKoroExpiredRecovery': 'SmartOKICA残高に移動（有効期限切れ）',
    'Trade.TransactionType.SmaKoroUnfinishedRecovery': 'SmartOKICA残高に移動（処理未了）',
    'Trade.TransactionType.SmaKoroCancelExpired': 'SmartOKICA残高への移動取消（有効期限切れ）',
    'Trade.TransactionType.SmaKoroCancel': 'SmartOKICA残高への移動取消',
    'Trade.TransactionType.SmaKoroCancelCardExchange': 'SmartOKICA残高への移動取消（カード交換/払戻）',
    'Trade.TransactionType.SmaKoroCancelRecovery': 'SmartOKICA残高に移動（取消リカバリ）',
    'Trade.TransactionType.OkiCharge': 'カードチャージ',
    'Trade.TransactionType.OkiChargeCancel': 'カードチャージ取消',
    'Trade.TransactionType.OkiFixed': 'カード決済',
    'Trade.TransactionType.OkiCancel': 'カード決済取消',
    'Trade.TransactionType.PointReduce': 'ポイント還元',

    'Trade.AccountType': '決済種別',
    'Trade.AccountType.SmartOKica': 'SmartOKICA残高',
    'Trade.AccountType.OkicaCard': 'OKICAカード残額',
    'Trade.AccountType.CreditCard': 'クレジットカード',
    'Trade.AccountType.Bank': '銀行口座',
    'Trade.AccountType.OkicaPoint': 'OKICAポイント',

    'Trade.Unfinish.Unfinished': '未了',
    'Trade.Unfinish.Eliminated': '未了（解消済み）',
    'Trade.Unfinish.Failed': '未了（失敗）',
    'Trade.Unfinish.Finished': '未了以外',

    'Trade.DebitTitle': '勘定科目(借方)',
    'Trade.DebitAccountType': '決済種別(借方)',
    'Trade.DebitAmount': '金額(借方)',
    'Trade.CreditTitle': '勘定科目(貸方)',
    'Trade.CreditAccountType': '決済種別(貸方)',
    'Trade.CreditAmount': '金額(貸方)',
    'Trade.Remarks': '摘要欄',
    'Trade.PaymentNo': '決済番号',
    'Trade.TerminalId': '端末機識別番号',
    'Trade.Unfinish': '未了',
    'Trade.UnfinishEliminatedDate': '未了解消日',
    'Trade.PaymentAgencyName': '決済代行業者名',
    'Trade.CreditCardGmoForward': 'GMO仕向け先コード',
    'Trade.CreditCardGmoApprove': 'GMO承認番号',
    'Trade.CreditCardGmoTranId': 'GMOトランザクションID',
    'Trade.CreditCardGmoTranDate': 'GMO決済日時',
    'Trade.PaymentBillNumber': '請求書番号',
    'Trade.PaymentCancelTransactionId': '取消取引ID',
    'Trade.Status': 'ステータス',
    'Trade.Status.Processing': '処理中',
    'Trade.Status.Complete': '完了',
    'Trade.Status.Failure': '失敗',
    'Trade.Amount': '金額',
    'Trade.TransactionId': '取引ID',
    'Trade.CardIdi': 'カードIDI',
    'Trade.CardDtlSeq': 'カード一件明細ID',
    'Trade.CardDtlSeqLoopCnt': '一件明細IDループカウンタ（カード）',
    'Trade.CardDtlFinishDt': '一件明細確定日時（カード）',

    //精算一覧
    'ListDownload.Title': '精算一覧',
    //精算書確認
    'ConfirmPayment.Title': '精算書確認',
    //精算（金融関連）
    'Financial.Title': '精算（金融関連）',
    //手数料一覧
    'FeeList.Title': '手数料一覧',

    //プロフィール
    'Profile.Title': 'プロフィール',


    //代表加盟店
    'Acquirer.Title': '代表加盟店',
    'Acquirer.Create': '代表加盟店申請',
    'Acquirer.Search': '検索',
    'Acquirer.Name': '代表加盟店名',
    'Acquirer.Status': 'ステータス',
    // application details
    'Acquirer.ApplicationDetails': '代表加盟店申請内容',
    'Acquirer.Cancellation': '代表加盟店解約',




    //Text field labels 
    'Label.Title': '例）',
    'Label.ShopCd1': '13桁で入力してください',
    'Label.ShopCd2': '4桁で入力してください',
    'Label.ShopCd3': '6桁で入力してください',
    'Label.ShopCd4': '6桁で入力してください',

    //加盟店
    'Merchant.Title': '加盟店',
    'Merchant.Name': '加盟店名',
    'Merchant.Create': '加盟店申請',
    'Merchant.Type': '区分',
    'Merchant.Status': 'ステータス',
    'Merchant.Status.Applying': '申請',
    'Merchant.Status.CheckPassed': '審査OK',
    'Merchant.Status.Registered': '登録完了',
    'Merchant.Status.CancelletionApplying': '解約申請',
    'Merchant.Status.Cancel': '解約',
    //Member store application (new)
    'Merchant.ContactName': '担当者氏名',
    'Merchant.ContactNameInFurigana': '担当者氏名 (フリガナ)',
    'Merchant.PhoneNumber': '電話番号',
    'Merchant.MailAddress': 'メールアドレス',
    'Merchant.BusinessForm': '事業形態',
    'Merchant.Corporate': '法人',
    'Merchant.IndividualBusiness': '個人事業主',
    'Merchant.CorporateName': '法人名 ※法人以外は屋号',
    'Merchant.CorporateNameInFurigana': '法人名 (フリガナ) ※法人以外は屋号',
    'Merchant.CorporateNumber': '法人番号',
    "Merchant.StoreCodeLevel1": "店舗識別コード (レベル1)",
    "Merchant.StoreCodeLevel2": "店舗識別コード (レベル2)",
    "Merchant.CorporateCodeType": '店舗識別コード種別',
    "Merchant.CorporateCodeTypeOkica": '独自',
    "Merchant.CorporateCodeTypeJPQR": 'JPQR',
    'Merchant.NameInEng': '加盟店名（英字表記)',
    //Merchant step names  
    "Merchant.StepOne": '担当者情報',
    "Merchant.StepTwo": '加盟店情報',
    "Merchant.StepTwo.Acquirer": '代表加盟店情報',
    "Merchant.StepThree": '代表者情報',
    "Merchant.StepFour": 'ロ座情報',
    "Merchant.StepFive": '手数料情報',
    "Merchant.StepSix": 'アカウント情報',
    //Merchant Step One Fields
    'Merchant.StepOneTitle': '担当者情報入力',
    'Merchant.FullName': '氏名',
    'Merchant.FullNameFurigana': '氏名(フリガナ)',
    'Merchant.PhoneNumber': '電話番号',
    'Merchant.Mail': 'メールアドレス',
    'Merchant.Department': '部署',
    //Merchant Step Two Fields
    'Merchant.StepTwoTitle': '加盟店情報入力',
    'Merchant.StepTwoTitle.Acquirer': '代表加盟店情報入力',
    //some fields name are same as above 
    'Merchant.Place': '所在他',
    'Merchant.PostalCode': '郵便番号',
    'Merchant.FaxNumber': 'FAX番号',
    'Merchant.Capital': '資本金(単位：万)',
    'Merchant.AnnualSales': '年商(単位：万)',
    'Merchant.EstablishDate': '設立年月日',
    'Merchant.NoOfEmployees': '従業員数',
    'Merchant.NoOfStores': '店舗数',
    'Merchant.IndustryCategory': '業種カテゴリ',
    'Merchant.IndustrySubCategory': '業種サブカテゴリ',
    'Merchant.BusinessDetail': '事業内容',
    //Merchant Step Three Fields
    'Merchant.StepThreeTitle': '代表者情報入力',
    //some fields name are same as in step one
    'Merchant.BirthDate': '生年月日',
    'Merchant.Address': '住所',
    'Merchant.Sex': '性別',
    'Merchant.SexMale': '男性',
    'Merchant.SexFemale': '女性',
    //Merchant Step Four Fields
    'Merchant.StepFourTitle': 'ロ座情報入力',
    'Merchant.BankName': '金融機関名',
    'Merchant.BankCode': '金融機関コード',
    'Merchant.BranchName': '支店名',
    'Merchant.BranchNumber': '支店番号',
    'Merchant.AccountType': '口座種別',
    'Merchant.AccountTypeSavings': '普通',
    'Merchant.AccountTypeCurrent': '当座',
    'Merchant.AccountNumber': '口座番号',
    'Merchant.AccountHolder': '口座名義',
    'Merchant.AccountHolderFurigana': '口座名義 (フリガナ)',
    'Merchant.ExternalLinkCd': '外部連携コード',
    //Merchant Step Five Fields
    'Merchant.StepFiveTitle': '手数料情報入力',
    'Merchant.Period': '期間',
    'Merchant.Shop': 'ショップ',
    'Merchant.GeneralStore': '一般店舗',
    'Merchant.Taxi': 'タクシー ',
    'Merchant.Retail': '大規模小売',
    'Merchant.Charge': 'チャージ',
    'Merchant.SystemFeeRate': 'システム手数料率',
    'Merchant.OKICACardPayment': 'OKICAカード決済',
    'Merchant.QRBalanceSettlement': 'QR残高決済',
    'Merchant.BrandCharge': 'ブランド負担',
    'Merchant.ChargeCommissionRate': 'チャージ手数料率',
    'Merchant.OKICACardCharge': 'OKICAカードチャージ',
    'Merchant.OKICACardValue': 'OKICAカードバリュー移動',
    'Merchant.CreditFeeRate': 'クレジット手数料率',
    'Merchant.SystemFee': 'システム手数料',
    'Merchant.BankChargeRate': '銀行手数料率',
    'Merchant.PaymentCycle': '精算サイクル',
    'Merchant.PaymentCycle1': '月1回',
    'Merchant.PaymentCycle2': '月2回',
    'Merchant.PaymentCycle3': '月4回',
    'Merchant.FromDate': '開始日',
    'Merchant.ToDate': '終了日',
    //Merchant Step Six Fields
    'Merchant.StepSixTitle': 'アカウント情報入力',
    'Merchant.AccountName': 'アカウント名',
    'Merchant.Password': 'パスワード',
    'Merchant.Division': '区分',
    'Merchant.DivisionName': '代表加盟店',
    // Merchant application details
    'Merchant.ConfirmApplicationDetails': '申請内容確認',
    'Merchant.HelperTextOK': '申請内容をOKする場合、「申請OK」ボタンをクリックしてください。',
    'Merchant.HelperTextDelete': '申請内容を削除する場合、「削除」ボタンをクリックしてください。',
    'Merchant.MemberStoreApplicationDetails': '代表加盟店申請内容',
    //Merchant resgistration completed 
    'Merchant.MemberStoreInfo': '代表加盟店情報',
    //Merchant detail edit (update message)
    'Merchant.HelperUpdateText': '変更したい項目を編集し‘「入力した内容に変更」ボタンをクリックしてください。',
    // Confirmation screen (step seven)
    'Merchant.ConfirmTitle': '入力内容確認',
    'Merchant.ConfirmDesc': '入力内容を確認し、間違いがなければ、「登録」ボタンをクリックしてください。',
    'Merchant.Notice': 'お知らせ',
    'Merchant.TransactionManagement': '取引管理',
    'Merchant.ListOfPayments': '精算一覧',
    'Merchant.Confirmation': '確認',
    'Merchant.Profile': 'プロフィール',
    'Merchant.MerchantManagement': '加盟店管理',
    'Merchant.StoreManagement': '店舗管理',
    'Merchant.TerminalManagement': '端末管理',
    'Merchant.PointManagement': 'ポイント管理',
    'Merchant.PointTotal': 'ポイント集計',
    'Merchant.AccountManagement': 'アカウント管理',
    'Merchant.EditTitle': '加盟店申込',
    'Merchant.EditDesc': '下記のフォームに情報を入力し、「入力内容の確認」ボタンをクリックしてください。',
    'Merchant.AppDesc': '入力内容を確認し、問違いが無ければ、「申込」ボタンをクリックしてください。',
    'Merchant.AppDetails': '加盟店申し込み内容',
    'Merchant.ApplicationAcceptance': '申し込み受付完了',
    'Merchant.ThankYouText': 'お申込みいただきありがとうございました。',
    'Merchant.WaitText': '審査完了まで、今しばらくお待ちください。',
    'Merchant.ResultText': '審査完了後、お客様のメールアドレス宛に、審査結果をお送りいたします。',
    'Merchant.MailText': 'メールアドレス: ',
    'Merchant.MailFilterText': 'メールフィルターを設定している場合は、smart_okica@okica.jpの受信許可設定をお願いいたします。',
    'Merchant.ApplicationDetails': '加盟店申請内容',
    'Merchant.Cancellation': '加盟店解約',
    'Merchant.CancelReason': '解約理由',
    'Merchant.Cancelletion.Title1': '解約すると、全ての登録情報が削除されます。元に戻せなくなりますのでご注意ください。',
    'Merchant.Cancelletion.Title2': '解約理由を選択し、「解約」ボタンをクリックしてください。',
    'Merchant.CancelReason.1': '当サービスに使いにくさ、不便さ、不安等を感じる為',
    'Merchant.CancelReason.2': '当サービスの利用客・利用機会が少ない為',
    'Merchant.CancelReason.3': '当サービスの決済手数料が有料化された場合、利用しない可能性がある為',
    'Merchant.CancelReason.4': '弊社サポートセンター対応に不満・不安がある為(電話・メール等)',
    'Merchant.CancelReason.5': '弊社営業対応に不満・不安がある為',
    'Merchant.CancelReason.6': '他のQRコード決済サービスを利用する為',
    'Merchant.CancelReason.7': 'QRコード決済(キャッシュレス決済)そのものに抵抗・不安がある為',
    'Merchant.CancelReason.8': '閉店・事業撤退等によりサービス不要となった為',
    'Merchant.CancelReason.9': '運営方針等の変更によりサービス不要となった為',
    'Merchant.CancelReason.10': 'ご登録情報の変更・修正の為',
    'Merchant.CancelReason.11': '重複登録(申込)の為',
    'Merchant.CancelReason.12': '意図しない登録(申込)の為',
    'Merchant.CancelReason.13': '代表者様が逝去された為',
    'Merchant.CancelReason.99': 'その他',


    //精算
    'Adjustment.ListOfPayments': '精算一覧',
    'Adjustment.YearAndMonth': '年月',
    'Adjustment.FixedDate': '確定日',
    'Adjustment.MerchantName': '加盟店名',
    'Adjustment.MerchantType': '加盟店タイプ',
    'Adjustment.AcquirerName': '代表加盟店名',
    'Adjustment.AmountPaid': '支払額',
    'Adjustment.AmountBilled': '請求額',
    'Adjustment.UnprocessedAmount': '処理未了額',
    'Adjustment.Elapse': '処理未了額（過去分）',
    'Adjustment.CarryOver': '処理未了額（繰越分）',
    'Adjustment.Payee': '振込先',
    'Adjustment.PayOffUnprocessedElapse': '精算未了（過去分）',
    'Adjustment.PayOffUnprocessedCarryOver': '精算未了（繰越分）',
    'Adjustment.Type': '種別',
    'Adjustment.ProcessingDate': '処理日時',
    'Adjustment.AmountOfMoney': '金額',
    'Adjustment.SettlementByDate': '精算日別',
    'Adjustment.Date': '日付',
    'Adjustment.SettlementDetail': '精算詳細',
    'Adjustment.MerchantList': '加盟店一覧',
    'Adjustment.PaymentMerchantList': '精算書確認（加盟店一覧）',
    'Adjustment.PaymentConfirmation': '精算書確認',
    'Adjustment.DeadLine': '締切日',
    'Adjustment.AccountStatement': '精算書',
    'Adjustment.CSVFileDaily': '日別CSVファイル',
    'Adjustment.CSVFileDetail': '明細CSVファイル',
    'Adjustment.CSVFilePointDetail': 'ポイント明細CSVファイル',
    'Adjustment.BankPayment': '銀行精算',
    'Adjustment.ResultsTitle': '結果一覧',
    'Adjustment.CreditPayment': 'クレジット精算',
    'Adjustment.Bank': '銀行',
    'Adjustment.PaymentAgent': '決済代行業者',
    'Adjustment.Period': '期間',
    'Adjustment.TotalFee': '合計金額',
    'Adjustment.BankSettlementByDate': '銀行精算日別',
    'Adjustment.CreditCardPayment': 'クレジットカード精算',
    'Adjustment.CreditSettlementByDate': 'クレジット精算日別',
    'Adjustment.Issuer': 'イシュア',
    'Adjustment.Card': 'カード',
    'Adjustment.Brand': 'ブランド',
    'Adjustment.QR': 'QR',
    'Adjustment.Charge': 'チャージ',
    'Adjustment.Transfer': '移動',
    'Adjustment.System': 'システム',
    'Adjustment.FeeList': '手数料一覧',

    //精算-手数料一覧
    'FeeList.List': '手数料一覧',
    'FeeList.Date': '日付',
    'FeeList.AcquirerName': '代表加盟店名',
    'FeeList.MerchantName': '加盟店名',
    'FeeList.CreditCardPaymentAgencyName': 'ショップ',
    'FeeList.AcquirerRow': '代表',
    'FeeList.GeneralRow': '一般',
    'FeeList.TotalRow': '加盟店名',
    'FeeList.SystemFee': 'システム手数料',
    'FeeList.ChargeFee': 'チャージ手数料',
    'FeeList.CreditFee': 'クレジット',
    'FeeList.BankFee': '銀行',
    'FeeList.Card': 'カード',
    'FeeList.Brand': 'ブランド',
    'FeeList.Qr': 'QR',
    'FeeList.Charge': 'チャージ',
    'FeeList.Exchange': '移動',
    'FeeList.System': 'システム',

    //店舗
    'Shop.Title': '店舗',
    'Shop.MerchantList': '店舗（加盟店一覧）',
    'Shop.Name': '店舗名',
    'Shop.ShopFName': '店舗名（フリガナ）',
    'Shop.ShopEName': '店舗名（英字表記）',
    'Shop.ShopPostalCd': '郵便番号',
    'Shop.ShopAddress': '住所',
    'Shop.ShopEAddress': '住所（英字表記）',
    'Shop.Latitude': '緯度（度数表記　世界測地系）',
    'Shop.Longitude': '経度（度数表記　世界測地系）',
    'Shop.ShopTel': '電話番号',
    'Shop.ShopFax': 'FAX番号',
    'Shop.Merchant': '加盟店',
    'Shop.MerchantName': '加盟店名',
    'Shop.ShopType': '店舗形態',
    'Shop.ShopType.Fixed': '固定',
    'Shop.ShopType.Movable': '可動式',
    'Shop.ShopCd3': '店舗識別コード（レベル3）',
    'Shop.DealsInfo': 'お得な情報',
    'Shop.Status': 'ステータス',
    'Shop.Create': '追加',
    'Shop.CreateTitle': '店舗情報入力',
    'Shop.CreateDesc': '下記のフォームに店舗情報を入力し、「入力内容の確認」ボタンをクリックしてください。',
    'Shop.ConfirmTitle': '入力内容確認',
    'Shop.ConfirmDesc': '入力内容を確認し、間違いがなければ、「登録」ボタンをクリックしてください。',
    'Shop.EditTitle': '店舗情報編集',
    'Shop.EditDesc': '変更したい項目を編集し、「登録」ボタンをクリックしてください。',
    'Shop.ShopEntryStep1Title': '店舗情報',
    'Shop.ShopEntryStep2Title': 'アカウント情報',
    'Shop.BulkRegistration': '一括登録',

    //profile
    'Shop.Information': '店舗情報',

    //端末
    'Terminal.Title': '端末',
    'Terminal.Id': '端末機識別番号',
    'Terminal.InstallId': '機器設置時識別番号',
    'Terminal.ModelCd': '機種',
    'Marchine.Id': '物販端末ID',
    'Shop.Name': '店舗名',
    'Installed': '設置',
    'Terminal.Create': '端末追加',
    'Terminal.Type': '端末タイプ',
    'ShopCd4': '店舗識別コード(レベル4)',
    'Terminal.Merchant.Title': '端末（加盟店一覧）',
    'Terminal.Merchant.Name': '加盟店',
    'Terminal.Merchant.Type': '加盟店タイプ',
    'Terminal.Merchant.Type.Acquirer': '代表',
    'Terminal.Merchant.Type.General': '一般',
    'Terminal.Shop': '店舗',
    'Terminal.MachineModelCd': '機種コード',
    'Terminal.MachineModelCd.Clerk': '1071:係員型',
    'Terminal.MachineModelCd.Customer': '1072:顧客型',
    'Terminal.MachineId': '物販端末ID',
    'Terminal.MachineRwCd': '物販端末R/Wコード',
    'Terminal.ApplyStartDate': '有効日付(開始)',
    'Terminal.ApplyStopDate': '有効日付(終了)',
    'Terminal.TerminalType': '端末タイプ',
    'Terminal.TerminalType.Sticker': 'ステッカー',
    'Terminal.TerminalType.TerminalQr': 'QR',
    'Terminal.TerminalType.TerminalCard': 'カード',
    'Terminal.TerminalType.TerminalCardQr': 'QRカード',
    'Terminal.TerminalType.Tablet': 'タブレット',
    'Terminal.ShopCd4': '店舗識別コード（レベル4）',
    'Terminal.MerchantOrgInfo': '独自識別情報',
    'Terminal.IsInstalled': '設置フラグ',
    'Terminal.IsInstalled.Notinstalled': '未設置',
    'Terminal.IsInstalled.Installed': '設置済',
    'Terminal.IsCharge': 'チャージフラグ',
    'Terminal.IsCharge.Notavailable': 'チャージ機能なし',
    'Terminal.IsCharge.Available': 'チャージ機能あり',
    'Terminal.CreateTitle': '端末情報入力',
    'Terminal.CreateDesc': '下記のフォームに端末情報を入力し、「登録」ボタンをクリックしてください。',
    'Terminal.ConfirmTitle': '入力内容確認',
    'Terminal.ConfirmDesc': '入力内容を確認し、間違いがなければ、「登録」ボタンをクリックしてください。',

    //ポイント管理
    'PointManagement.Title': 'ポイント管理',
    'PointManagement.SettingsList': 'ポイント設定一覧',
    'PointManagement.PointKbn': 'ポイント種別',
    'PointManagement.PointKbn.Card': 'カード',
    'PointManagement.PointKbn.Qr': 'QR',
    'PointManagement.PointName': '設定名',
    'PointManagement.Period': '期間',
    'PointManagement.PointRate': 'ポイント率',
    'PointManagement.StartDate': '期間(開始日)',
    'PointManagement.EndDate': '期間(終了日)',
    'PointManagement.ApplicableCategory': '適用区分',
    'PointManagement.AddPointSetting': 'ポイント設定追加',
    'PointManagement.AddDesc': '追加するポイントの設定内容を入カし、「登録」ボタンをクリックしてください。', 
    'PointManagement.OKICASourceRatio': '原資負担割合 OKICA',
    'PointManagement.MerchantSourceRatio': '原資負担割合 加盟店',
    'PointManagement.Valid': '有効',
    'PointManagement.Invalid': '無効',
    'PointManagement.PointSettingDetails': 'ポイント設定詳細',
    'PointManagement.PointInformation': 'ポイント情報',
    'PointManagement.EditPointSetting': 'ポイント設定編集',
    'PointManagement.EditDesc': '変更したい項目を編集し、「登録」ボタンをクリックしてください。', 
    'PointManagement.Merchant': '加盟店',

    //ポイント集計
    'PointAggregate.Title': 'ポイント集計',
    'PointAggregate.YearAndMonth': '年月',
    'PointAggregate.PointAggregateList': 'ポイント集計表',

    //手数料
    'FeeAggregate.Title': '手数料',

    //手数料管理
    'FeeManagement.Title': '手数料管理',
    'FeeManagement.List': '手数料設定一覧',
    'FeeManagement.MerchantName': '加盟店名',
    'FeeManagement.MerchantType': '加盟店タイプ',
    'FeeManagement.Period': '期間',
    'FeeManagement.FeeSettingDetails': '手数料設定詳細',
    'FeeManagement.CreateTitle': '手数料設定入力',
    'FeeManagement.CreateDesc': '下記のフォームに手数料設定情報を入力し、「登録」ボタンをクリックしてください。',
    'FeeManagement.FeeInformation': '手数料情報',
    'FeeManagement.TargetDay': '対象日付',

    //アカウント
    'Account.Title': 'アカウント',
    'Account.MerchantList': 'アカウント（加盟店一覧）',
    'Account.Name': '名称',
    'Account.Role': '区分',
    'Account.Role.SystemAdmin': 'システム管理者',
    'Account.Role.Brand': '沖縄IC',
    'Account.Role.Acquirer': '代表加盟店',
    'Account.Role.Merchant': '加盟店',
    'Account.Role.Store': '店舗',
    'Account.Org': '所属',
    'Account.Email': 'メールアドレス',
    'Account.Username': 'ログインID(メールアドレス)',
    'Account.Password': 'パスワード',
    'Account.PasswordRepeat': 'パスワード確認',
    'Account.Permission': '権限',
    'Account.Status': 'ステータス',
    'Account.Status.InValid': '無効',
    'Account.Status.Valid': '有効',
    'Account.Create': '追加',
    'Account.CreateTitle': 'アカウント情報入力',
    'Account.CreateDesc': '下記のフォームにアカウント情報を入力し、「登録」ボタンをクリックしてください。',
    'Account.ConfirmTitle': '入力内容確認',
    'Account.ConfirmDesc': '入力内容を確認し、間違いがなければ、「登録」ボタンをクリックしてください。',

    //販促物
    'SalesPromotion.Title': '販促物',
    'SalesPromotion.MerchantName': '加盟店名',
    'SalesPromotion.ShopName': '店舗名',
    'SalesPromotion.TerminalId': '端末機識別番号',
    'SalesPromotion.QrCodeSize': 'QRコードサイズ',
    'SalesPromotion.Download': 'ダウンロード',

    //利用規約
    'TermsOfService.Title': '利用規約',

    //ボタンの説明
    'Button.Search': '検索',
    'Button.ConditionClear': '条件クリア',
};
export default ja;
